import React from 'react';
import { useQuery } from '@apollo/client';
import { Loader } from 'components';
import Alert from '@material-ui/lab/Alert';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const isProd = publicRuntimeConfig.env === 'prod';

const Query = ({ children, query, id, slug }) => {
    const { data, loading, error } = useQuery(query, {
        variables: { id, slug, where : isProd ? { in_production: true }: {} },
        ssr: true,
    });

    if (loading) return <Loader show={ true } />;
    if (error) {
        return (
            // TODO: styling
            <Alert severity="error" variant="filled">
                <h4>Der skete desværre en fejl</h4>
                { JSON.stringify(error) }
            </Alert>
        );
    }

    return children({ data });
};

export default Query;
